var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4c-.3 0-.5.1-.7.3L4.3 6.3c-.4.4-.4 1 0 1.4L11.6 15l-7.3 7.3c-.4.4-.4 1 0 1.4l2 2c.4.4 1 .4 1.4 0L15 18.4l7.3 7.3c.4.4 1 .4 1.4 0l2-2c.4-.4.4-1 0-1.4L18.4 15l7.3-7.3c.4-.4.4-1 0-1.4l-2-2c-.4-.4-1-.4-1.4 0L15 11.6 7.7 4.3C7.5 4.1 7.3 4 7 4z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.e5439000d59a8bfa57b301de6e628985.svg";
export { ForwardRef as ReactComponent };